// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-navigator__controls__container{display:flex;flex-grow:1;align-self:flex-end}@media(min-width:200px)and (max-width:750px){.tree-navigator__toolbar:not(.image-small) .v-toolbar__content{max-width:100%;flex-direction:column}.tree-navigator__toolbar:not(.image-small) .tree-navigator__image{max-width:90%!important;max-height:200px!important}.tree-navigator__toolbar:not(.image-small) .tree-navigator__controls__container{flex-grow:0;align-self:auto}}", ""]);
// Exports
module.exports = exports;
